import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        setShown(true);
        io.disconnect();
      }
    }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ transitionDelay: `${delay}ms` }} className={`reveal ${shown ? "reveal-in" : ""} ${className}`}>
      {children}
    </div>
  );
};

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-[#1E9BFF]">
    <span>{index}</span>
    <span className="h-px w-10 bg-[#1E9BFF]" />
    <span>{children}</span>
  </div>
);
